import { getAuthData } from '@common/helpers/auth';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';

const success = (result) => ({ success: true, data: result.data[0] });
const notFound = (message) => ({ success: false, data: null, errorMessage: message });

export const findPlayerById = async (clientId) => {
  const { token } = getAuthData();

  const result = await swarmRequest({ token, filter: { id: +clientId } }, 'terminal_find_player');

  if (!result.data?.length) return notFound('Player with this id is not found');

  return success(result);
};

export const findPlayerByUsername = async (username) => {
  const { token } = getAuthData();

  const result = await swarmRequest({ token, filter: { login: username } }, 'terminal_find_player');

  if (!result.data?.length) return notFound('Player with this username is not found');

  return success(result);
};
